package com.appsyde.shared.network

import com.appsyde.shared.getAccessToken
import io.ktor.client.HttpClient
import io.ktor.client.engine.js.Js
import io.ktor.client.plugins.contentnegotiation.ContentNegotiation
import io.ktor.client.plugins.cookies.AcceptAllCookiesStorage
import io.ktor.client.plugins.cookies.HttpCookies
import io.ktor.serialization.kotlinx.json.json
import kotlinx.serialization.json.Json
import org.w3c.fetch.INCLUDE
import org.w3c.fetch.RequestCredentials

actual fun createHttpClient(): HttpClient {
    return HttpClient(Js) {

        // ✅ Send cookies on cross-origin requests (e.g. 8080 -> 8081)
        engine {
            configureRequest {
                credentials = RequestCredentials.INCLUDE
            }
        }

        install(ContentNegotiation) {
            json(Json {
                prettyPrint = true
                isLenient = true
                ignoreUnknownKeys = true
            })
        }

        install(HttpCookies) {
            storage = AcceptAllCookiesStorage()
        }

        // Token read at request time so GET /me after session-token exchange includes Bearer
        install(BearerTokenPlugin) {
            tokenProvider = { getAccessToken() }
        }
    }
}
